import(/* webpackMode: "eager" */ "/Users/arielmuslera/code/otto-the-butler/web/node_modules/next/dist/client/link.js");
